import { EntityName } from '../types/enums';

export enum FieldPrefix {
  lpco = '',
  attachedDocument = 'attachedDocuments.',
  item = 'items.',
  beneficiary = 'beneficiaries.',
  additionalFields = 'additionalFields.',
  dbOptionAdditionalFields = 'dbOptionAdditionalFields.',
  fee = 'fees.',
  additionalField = 'af_',
  packages = 'items.packages.',
  treatments = 'items.treatments.',
}

export const entityToFieldPrefixMap: Record<EntityName, FieldPrefix> = {
  [EntityName.LPCO]: FieldPrefix.lpco,
  [EntityName.ATTACHED_DOCUMENT]: FieldPrefix.attachedDocument,
  [EntityName.ITEM]: FieldPrefix.item,
  [EntityName.BENEFICIARY]: FieldPrefix.beneficiary,
  [EntityName.FEE]: FieldPrefix.fee,
  [EntityName.ADDITIONAL_FIELD]: FieldPrefix.additionalField,
  [EntityName.ITEM_ADDITIONAL_FIELD]: FieldPrefix.additionalField,
  [EntityName.ITEM_PACKAGE]: FieldPrefix.packages,
  [EntityName.ITEM_TREATMENT]: FieldPrefix.treatments,
};
